const mapStateToProps = (state) => ({
  reduxRecords: state.reduxRecords,
  reduxVincheck: state.reduxVincheck,
});

export default mapStateToProps;
